import React from 'react'
export default function Visual({ type }) {
  return (
    <div className={'visual ' + type}>
      {type === 'reservation' && (
        <>
          <div className="browser">
            <div className="topline" />
            <div className="vstats">
              <i />
              <i />
              <i />
            </div>
            <div className="vchart" />
          </div>
          <div className="phone">
            <b />
            <i />
            <i />
            <i />
          </div>
        </>
      )}
      {type === 'beauty' && (
        <>
          <div className="beauty">
            <small>ESTÉE LAUDER</small>
            <b>
              Advanced
              <br />
              Night Repair
            </b>
          </div>
          <div className="bottle">EL</div>
        </>
      )}
      {type === 'dashboard' && (
        <>
          <div className="sidebar" />
          <div className="dash">
            <div className="dhead" />
            <div className="dcards">
              <i />
              <i />
              <i />
            </div>
            <div className="dchart" />
          </div>
        </>
      )}
      {type === 'risk' && (
        <>
          <div className="map">
            <i />
            <i />
            <i />
            <i />
          </div>
          <div className="risk-card">
            <b>RISK</b>
            <span>LIVE DATA</span>
          </div>
        </>
      )}
      {type === 'notify' && (
        <>
          <div className="notify-box">
            <b>01</b>
            <span>MESSAGE SENT</span>
            <i />
          </div>
          <div className="notify-box second">
            <b>02</b>
            <span>DELIVERED</span>
            <i />
          </div>
        </>
      )}
      {type === 'microsite' && (
        <>
          <div className="site-window">
            <b>BRAND</b>
            <i />
            <i />
            <i />
          </div>
          <div className="site-card" />
        </>
      )}
    </div>
  )
}
